import {
  ChangeDetectionStrategy,
  Component,
  inject,
  output,
  ViewEncapsulation,
} from '@angular/core';

import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonComponent, FormFieldComponent, MessageComponent } from '@akostm/orbit-ui';
import { TenantStore } from '../../../stores';
import { SetPassword } from '../../../interfaces';

@Component({
  selector: 'shared-set-password-form',
  standalone: true,
  imports: [
    ButtonComponent,
    FormFieldComponent,
    ReactiveFormsModule,
    TranslatePipe,
    MessageComponent
],
  templateUrl: './set-password-form.component.html',
  styleUrl: './set-password-form.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetPasswordFormComponent {
  readonly tenantStore = inject(TenantStore);
  readonly #translateService: TranslateService = inject(TranslateService);
  errorMessage = '';
  tenantName = this.tenantStore.name();
  setPassword = output<SetPassword>();

  setPasswordFrom = new FormGroup({
    password: new FormControl<string | null>(null),
    confirmPassword: new FormControl<string | null>(null),
  });

  get password() {
    return this.setPasswordFrom.get('password') as FormControl<string>;
  }

  get confirmPassword() {
    return this.setPasswordFrom.get('confirmPassword') as FormControl<string>;
  }

  onSubmit() {
    if (!this.password.value) {
      this.errorMessage = this.#translateService.instant('SHARED.SET_PASSWORD.PASSWORD_NOT_SET');
      return;
    }
    if (this.password.value !== this.confirmPassword.value) {
      this.errorMessage = this.#translateService.instant('SHARED.SET_PASSWORD.PASSWORDS_NOT_EQUAL');
      return;
    }
    this.errorMessage = '';
    const givenCredentials = { password: this.password.value };
    this.setPassword.emit(givenCredentials);
  }
}
